'use strict';

angular.module('MrDWebApp').controller('LocationCtrl', function(
  $scope,
  $q,
  $http,
  baseURL,
  $state,
  $stateParams,
  $window,
  $previousState,
  restaurants,
  $cookies,
  storage,
  landingItemsFactory,
  $rootScope,
  $timeout
) {

  var _lc = this;
  var firebaseObject = {}; // populates firebase event based on actions


  // ===========================================================================
  // Build MRD.COM target url  =================================================
  // ===========================================================================

  var p = window.location.pathname.split('/'); // ['', 'order', 'restaurants', ':lat', ':lon', ':street'] 
  var q = window.location.search.substring(1).split('&').map(function(p) { return p.split('='); });
  q.unshift(['latitude',p[3]],['longitude',p[4]],['street_name',p[5]]);
  q.push(['utm_source','mrdfood'],['utm_medium','website_homepage'],['utm_campaign','shop_mrd']);
  _lc.mrdUrl = 'https://www.mrd.com/?' + q.map(function(p) { return p.join('='); }).join('&');

  // ===========================================================================
  // Search and hints logic  ===================================================
  // ===========================================================================

  _lc.loading = $rootScope.stateIsLoading;
  _lc.isWorking = true;
  _lc.isSuccess = false;
  _lc.hasGeocoded = false;

  _lc.searchInput = '';
  _lc.searchTerm = '';
  _lc.searchFromHint = false;
  _lc.searchHints = [];
  _lc.searchIds = [];

  _lc.searchRestaurantIds = [];

  _lc.loadingHints = false;
  _lc.loadingList = false;


	_lc.allowed_item_types = ['tag','recommended_tag','restaurant','recommended_restaurant','recommended_restaurant_group','menu_item','recommended_menu_item'];

  //clear previous menus
  try {
    var menuKeys = storage.getKeys();
    for (var i = 0; i < menuKeys.length; i++) {
      var key = menuKeys[i];
      if (key.startsWith('menu_')) storage.remove(key);
    }
  } catch (error) {
    console.log('Could not clear menus.');
  }

  _lc._search = function(runSearch) {
    _lc.loadingHints = true;
    _lc.searchError = false;
    $http({
      url: baseURL + 'search/',
      method: 'POST',
      data: {
        meta: {
          lat: $scope._rc.variables.address.latitude,
          lon: $scope._rc.variables.address.longitude,
          user_id: $scope._rc.access.user.id
        },
        ids: _lc.searchRestaurantIds,
        text: _lc.searchInput
      }
    }).then(function(res) {
      if (res.data.items.length > 0) {
        _lc.searchHints = res.data.items;
        _lc.restaurantIndex = _lc.findRestaurantTileIndex(_lc.searchHints);
        _lc.resultsView = res.data.view;
        _lc.searchTitle = res.data.title;
        _lc.searchSubtitle = res.data.subtitle;
      } else {
        _lc.searchHints = false;
      }
      _lc.loadingHints = false;
      if (runSearch && _lc.searchHints[0] !== undefined && (_lc.searchHints[0].tiles[0].payload.items.length > 0 || _lc.searchHints[1].tiles[0].payload.items.length > 0)) {
        _lc.runOrganicSearch();
      }
      _lc.matchListToRestaurantResults();
      _lc.searchResultObject = res.data;

      if (_lc.searchResultObject.view === 'no_search_term') {
        _lc.firebaseEvent('tap_search_field_restaurant_list');
      }
    }, function(error) {
      _lc.loadingHints = false;
      _lc.searchError = true;
      _lc.firebaseEvent('error_search_restaurant_list', error);
      console.log('Search hints call failed: ', error);
    });
  };

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  //call this on built in filter too
  _lc.getRestaurantCount = function() {

    var cnt = 0;
    angular.forEach(_lc.restaurants.items, function(item) {
      angular.forEach(item.tiles, function(tile) {
        if (tile.type === 'restaurant') {
          cnt++;
        }
      });
    });
    return cnt;
  };

  _lc.runOrganicSearch = function() {
		if (_lc.searchHints[_lc.restaurantIndex]) {
			_lc.searchIds = _lc.searchHints[_lc.restaurantIndex].tiles[0].payload.ids;
			_lc.searchTerm = _lc.searchInput;
			_lc.searchInput = '';
			_lc.searchFromHint = false;
		}
  };

  // enter to search, or navigate hints using arrows
  _lc.searchKeypress = function($event) {
    if (event.which === 13) { // enter

      if (_lc.searchInput.length > 0) {

        if (!_lc.loadingHints && _lc.searchHints[0] !== undefined && (_lc.searchHints[0].tiles[0].payload.items.length > 0 || _lc.searchHints[1].tiles[0].payload.items.length > 0)) {
          _lc.runOrganicSearch();
        } else {
          _lc._search(true);
        }

        $event.target.blur();
      }

    } else if (event.which === 27) { // esc
      $event.target.blur();
    } else if (event.which === 38) { // arrow up
    } else if (event.which === 40) { // arrow down
    }
  };

  _lc.clickHint = function(hint) {
    // _lc.firebaseEvent('tap_search_item_restaurant_list', hint);
    $rootScope.$emit('lazyImg:refresh');
    $timeout(function() {
      $rootScope.$emit('lazyImg:refresh');
    }, 10);
  };

  _lc._debounceSearch = debounce(function() {
    _lc._search();
  }, 500); //animation duration

  _lc.searchRestaurantsByTextString = function() {
    //reset animation
    _lc._debounceSearch();
  };

  _lc.tapSearchBar = function() {
    if (_lc.searchHints.length < 1) {
      _lc._search();
    } else {
      _lc.firebaseEvent('tap_search_field_restaurant_list');
    }
  };

  _lc.findRestaurantTileIndex = function(searchHints) {
    var i;
    for (i = 0; i < searchHints.length; i++) {
      if (searchHints[i].tiles[0].type === 'restaurant_collection') {
        return i;
      }
    }
    return false;
  };

	// _lc.getRestaurantGroupLogos = function(hints) {
	//
	// 	const getRestaurantLogo = function (id) {
	// 		let logo_url;
	// 		_lc.restaurants.items.find(function(r){
	// 			if (r.tiles[0].payload.id === id) {
	// 				logo_url = r.tiles[0].payload.logo;
	// 			}
	// 		});
	// 		return logo_url;
	// 	};
	//
	// 	angular.forEach(hints, function(section) {
	// 		if (section.tiles[0].payload.item_type === 'recommended_restaurant_group') {
	//
	// 			angular.forEach(section.tiles[0].payload.items, function(item) {
	// 				if (!item.image_url && item.group_id) {
	// 					item.image_url = getRestaurantLogo(item.ids[0]);
	// 				}
	// 			});
	//
	// 		}
	// 	});
	//
	// 	return hints;
	// };

	_lc.matchListToRestaurantResults = function() {
	  _lc.searchHints
	  // .filter(function(hints){
	  //   // console.log("FILTER", hints.tiles[0].payload.item_type);
	  //   return hints.tiles[0].payload.item_type === 'recommended_restaurant' || hints.tiles[0].payload.item_type === 'restaurant';
	  // })
	  .forEach(function(hints){
	    hints.tiles[0].payload.items.forEach(function(hint){
	      var rest = _lc.restaurants.items.find(function(r){
	        return r.tiles[0].payload.id === hint.id;
	      });
	      if (rest) {
	        hint.open = rest.tiles[0].payload.open;
	        hint.online = rest.tiles[0].payload.online;
	        hint.future_opening_time = rest.tiles[0].payload.future_opening_time;
	        // console.log('Hint matched', hint);
					if (!hint.logo && rest.tiles[0].payload.logo) {
						hint.logo = rest.tiles[0].payload.logo;
					}
	      }

	    });
	  });

		_lc.restaurants.items.map(function (restaurant) {

		  var thisHint = false;

		  if (_lc.searchHints[0] !== undefined) {
		    thisHint = _lc.searchHints[0].tiles[0].payload.items.find(function (hint) {
		      return restaurant.tiles[0].payload.id === hint.id;
		    });

		    if (thisHint) {
		      thisHint.open = restaurant.tiles[0].payload.open;
		      thisHint.online = restaurant.tiles[0].payload.online;
		      thisHint.future_opening_time = restaurant.tiles[0].payload.future_opening_time;
		      console.log('Hint matched:', thisHint.id);
		    }

		    return false;
		  }

		});
	};

  // ===========================================================================
  // Landing items  ============================================================
  // ===========================================================================
  $previousState.memo('caller');

  _lc.prev = $previousState.get('caller');
  _lc.backLabel = 'Back to Search';

  $scope._rc.bodyClass = '';

  if (!$scope._rc.variables.hasLocation && !$stateParams.lat && !$stateParams.long) {
    if (window.env.domainSplit) window.location.href = '/';
    else $state.go('home');
  }

  $scope._rc.variables.hasLocation = true;

  // HARVEST URL QUERY PARAMS
  var address = {
    latitude: $stateParams.lat,
    longitude: $stateParams.lng,
    label: $stateParams.label,
    street_number: $stateParams.street_number,
    street_name: $stateParams.street_name.replace(/\+/g, ' '),
    suburb: $stateParams.suburb,
    city: $stateParams.city,
    province: $stateParams.province,
    postal_code: $stateParams.postal_code,
  };
  var savedAddress;
  if (!!address.label && $scope._rc.access.user && $scope._rc.access.user.saved_addresses) {
    // USE label TO VERIFY ADDRESS
    savedAddress = $scope._rc.access.user.saved_addresses.find(function(addr) {
      return addr.label === address.label;
    });
    if (savedAddress) address = Object.assign(address, savedAddress);
  } else if (address.latitude && address.longitude && $scope._rc.access.user && $scope._rc.access.user.saved_addresses) {
    // USE geolocation TO VERIFY ADDRESS
    savedAddress = $scope._rc.access.user.saved_addresses.find(function(a) {
      return a.latitude === address.latitude && a.longitude === address.longitude;
    });
    if (savedAddress) address = Object.assign(address, savedAddress);
  }
  //console.log("address",address)
  $scope._rc.variables.address = Object.assign({}, address);
  $scope._rc.cart.customer.address = Object.assign({}, address);
  storage.set('mrd-web-variables', $scope._rc.variables);
  storage.set('mrd-web-cart', $scope._rc.cart);
  // END OF FIX

  _lc.restaurants = restaurants;
  _lc.originalRestaurantListing = restaurants;

  $scope._rc.voteForm = {
    type: 'area-not-serviced'
  };

  if ($scope._rc.access.loggedin) {
    $scope._rc.voteForm.email = $scope._rc.access.user.name;
    _lc.hitmeEmail = $scope._rc.access.user.name;
  }
  if ($scope._rc.variables.address && $scope._rc.variables.address.latitude && $scope._rc.variables.address.longitude) {
    $scope._rc.voteForm.location = $scope._rc.variables.address.latitude + ', ' + $scope._rc.variables.address.longitude;
  }
	if ($scope._rc.variables.address) {
    $scope._rc.voteForm = Object.assign({}, $scope._rc.voteForm);
    Object.assign($scope._rc.voteForm, $scope._rc.variables.address);
  }

  _lc.backClick = function() {
    if (_lc.prev.state && _lc.prev.state.name === 'map') {
      $state.go('map');
    } else {
      if (window.env.domainSplit) window.location.href = '/';
      else $state.go('home');
    }
  };

  _lc.hitme = function() {
    if (_lc.hitmeEmailVisible) {
      var test = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //https://emailregex.com/
      if (_lc.hitmeEmail && _lc.hitmeEmail.match(test)) {
        _lc.hitmeEmailInvalid = false;

        _lc.hitmeEmailSending = true;
        $scope._rc.vote(_lc.hitmeEmail)
          .catch(function() {
            return;
          })
          .then(function() {
            $rootScope.$apply(function() {
              _lc.hitmeEmailVisible = false;
              _lc.hitmeEmailSending = false;
              _lc.hitmeEmailSent = true;
            });
          });
      } else {
        _lc.hitmeEmailInvalid = true;
      }
    } else {
      if (_lc.hitmeEmailSent) $state.go('home');
      _lc.hitmeEmailVisible = true;
      _lc.hitmeEmailSent = false;
    }
  };

  _lc.restaurants.$promise.then(function(restaurant) {

    _lc.isWorking = false;
    var dontShow = false;

    if ($previousState.get('caller').state) {
      if ($previousState.get('caller').state.name === 'item' ||
        $previousState.get('caller').state.name === 'menu') {
        dontShow = true;
      }
    }

    if (!restaurant.items || !restaurant.items.length) {
      $scope._rc.track('restaurant_list_page', 'view_address_not_serviced');
      $window._adjustEvent('rygbbz'); //viewed_area_not_servicable
    } else {
      restaurant.items = restaurant.items.filter(function(item) {
        return item.tiles[0].type === 'restaurant';
      });

      $scope._rc.track('restaurant_list_page', 'view_restaurant_list');
      $window._adjustEvent('wn17p7'); //viewed_restaurant_list
      // Assuming the list has been loaded and has restaurants in it.
      // console.log('Every time we get the landing items, we put it in angular storage / session , _lc.restaurants: '+_lc.restaurants.items);
      storage.set('restaurants', _lc.restaurants.items);

      // accumalate restaurant IDs
      _lc.searchRestaurantIds = restaurant.items.reduce(function(ar, item) {
        return ar.concat(item.tiles.map(function(tile) {
          return tile.payload.id;
        }));
      }, []);

      var item;
      if ($stateParams.select) { // RESTAURANT PRE-SELECT
        item = restaurant.items.reduce(function(rtn, i) {
          return rtn || i.tiles.find(function(t) {
            return t.type === 'restaurant' && '' + t.payload.id === $stateParams.select;
          });
        }, null);
        if (item) {
          _lc.setRestaurantTile(item);
        } else {
          console.log('Pre-selected restaurant out of bounds.');
          _lc.noPreselect = true;
        }
      }
      //GW: we need to search and update the restaurant stored in `variables`
      else if ($scope._rc.variables.restaurant) {
        var r = $scope._rc.variables.restaurant;
        item = restaurant.items.reduce(function(rtn, i) {
          return rtn || i.tiles.find(function(t) {
            return t.type === 'restaurant' && t.payload.id === r.id;
          });
        }, null);
        if (item) {
          delete $scope._rc.variables.restaurant.active_promotion;
          angular.extend($scope._rc.variables.restaurant, item.payload);
          //console.log('Variable Restaurant Updated.',$scope._rc.variables.restaurant);
          storage.set('mrd-web-variables', $scope._rc.variables);
        }
      }

    }

    if (restaurant.friendly_message) {
      /* Analytics */
      $scope._rc.trackCapacityDelaySurfaced();
      $rootScope.$broadcast('global_message:show', {
        'name': 'delay_popup',
        'for_state': 'location',
        'error': {
          'friendly_message': restaurant.friendly_message
        },
        'confirm': {
          'title': false,
          'message': '',
          'label': 'Okay, Got it!',
          'action': 'close',
          'value': true,
          'value_object': null
        },
        'deny': false
      });
    } else if (restaurant.promotion_popup && !dontShow) {
      $rootScope.$broadcast('global_message:show', {
        'name': 'promotion_popup',
        'for_state': 'location',
        'error': {
          'friendly_message': null
        },
        'confirm': {
          'title': restaurant.promotion_popup.title_text,
          'message': restaurant.promotion_popup.message_text,
          'label': 'Okay, Got it!',
          'action': 'close',
          'value': true,
          'value_object': null
        },
        'deny': false

      });
    }
  }, function(err) {
    console.log('promise error');
    // SERIOUS ERROR
    $rootScope.$broadcast('global_message:show', {
      'name': 'restaurants_load_failure',
      'for_state': 'location',
      'error': {
        'friendly_message': 'We\'re experiencing some difficulties. Please try again later.'
      },
      'confirm': {
        'title': false,
        'message': '',
        'label': 'Take me home...',
        'action': 'redirect',
        'value': 'home',
        'value_object': null
      },
      'deny': false
    });

  });

  _lc.reloadData = function() {
    location.reload();
  };

	_lc.getTile = function (requiredId) {
	  var i;
	  for (i = 0; i < _lc.restaurants.items.length; i++) {
	    if (_lc.restaurants.items[i].tiles[0].payload.id === requiredId) {
	      return _lc.restaurants.items[i].tiles[0];
	    }
	  }
	};

  _lc.setRestaurantTile = function(tile) {

    if (typeof tile === 'number') { // clicked restaurant (has tile)
      tile = _lc.getTile(tile);
    }
    if (tile === undefined) { // clicked tag (no tile)
      return false;
    }

    console.log('_lc.setRestaurantTile: ' + tile);
    _lc.isWorking = true;
    if ($scope._rc.cart.restaurant.id && tile.payload.id !== $scope._rc.cart.restaurant.id && $scope._rc.cart.items.length > 0) {

      $rootScope.$broadcast('global_message:show', {
        'name': 'selected_from_other_restaurant',
        'for_state': 'location',
        'error': {
          'friendly_message': 'Selecting food from a different restaurant will empty your current cart.'
        },
        'confirm': {
          'label': 'Clear Cart and Continue',
          'action': 'redirect',
          'value': 'menu',
          // 'value_object': restaurant
          'value_object': tile.payload
        },
        'deny': {
          'label': 'Back to Restaurant Menu',
          'action': 'redirect',
          'value': 'menu',
          'value_object': $scope._rc.variables.restaurant
        }
      });
    } else {

      console.log('pass the restaurant in here, otherwise menu.js has to make a call to get it');
      $scope._rc.variables.restaurant = tile.payload;

      // console.log('location.js, $scope._rc.variables.restaurant : ' + $scope._rc.variables.restaurant);
      if (tile.payload.delivery_option === 'collect') {
        $scope._rc.cart.type = 'collect';
      }

      storage.set('mrd-web-variables', $scope._rc.variables);

      if (tile.type === 'restaurant') {
        console.log('location.js, _lc.setRestaurant, tile for navigating from a restaurant to a restaurants menu: ');
        console.log('location.js, _lc.setRestaurant, tile.type === \'restaurant: ' + tile.type);

        $state.go('menu', {
          restaurantID: tile.payload.id,
          menuID: tile.payload.menu_id,
          restaurant: tile.payload
        });

      }
    }

  };

  //used as a back button, we filter within the page using the same url so a window refresh is the same as calling the landing items factory
  _lc.refreshList = function() {
    console.log('using refreshlist as a back button');
    $window.location.reload();

  };

  _lc.getIndicators = function(tile) {
    var indicatorString = '';
    var indicatorArray = tile.payload.indicators;
    for (var i = 0; i < indicatorArray.length; i++) {
      if (i < indicatorArray.length - 1) {
        indicatorString += indicatorArray[i].title + ', ';
      } else {
        indicatorString += indicatorArray[i].title;
      }
    }

    return indicatorString;
  };

  _lc.calculateRatingBucket = function(tile) {

    if (tile.payload.statistics !== undefined && tile.type === 'restaurant') {
      var value = tile.payload.statistics.cnt_food_quality_rating;
      var result = 0;
      if (value > 10000) {
        result = 10000;

      } else if (value > 1000) {
        result = (Math.floor((value - 1) / 1000)) * 1000;

      } else if (value > 500) {
        result = (Math.floor((value - 1) / 100)) * 100;

      } else if (value > 50) {
        result = (Math.floor((value - 1) / 50)) * 50;

      }
      if (result > 0) {
        return result + '+ ratings';
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  _lc.tileNext = function() {
    console.log('tileNext: ');
    document.querySelector('.tileSwiper').swiper.slideNext();
  };

  _lc.tilePrev = function() {
    console.log('tilePrev: ');
    document.querySelector('.tileSwiper').swiper.slidePrev();
  };

  _lc.firebaseEvent = function(e, itemType, obj) {

    // base keys
    // search field tap no_search_term
    firebaseObject = { // resets excess fields
      search_result_view_type: _lc.searchResultObject.view,
      search_result_section: _lc.searchResultObject.items[0].tiles[0].type,
      search_result_section_title: _lc.searchResultObject.items[0].tiles[0].payload.name,
      address_latitude: $scope._rc.variables.address.latitude,
      address_longitude: $scope._rc.variables.address.longitude,
      total_restaurant_count: _lc.restaurants.items.length
    };

    if (e === 'tap_search_field_restaurant_list') {
      // use base keys
      // TODO: change this in future as it's a temporary fix
      if (firebaseObject.search_result_section === 'collection') {
        firebaseObject.search_result_section = 'tag_collection';
      }
    } else if (e === 'tap_search_item_restaurant_list') {

      // restaurant tag tapped / no search term
      // ===
      // base object combined with:
      // selected_tag_name, selected_tag_count, item_index
      firebaseObject = Object.assign(firebaseObject, obj);

			// remove name or group id if undefined
			if (firebaseObject.restaurant_group_id === undefined) delete firebaseObject.restaurant_group_id;
			if (firebaseObject.selected_tag_name === undefined) delete firebaseObject.selected_tag_name;

			if (itemType === 'recommended_restaurant_group') {
				firebaseObject.selected_item_count = firebaseObject.selected_tag_count;
				delete firebaseObject.selected_tag_count;
			}

      // add search term for:
      // restaurant tag tapped / results matching or suggested
      // restaurant name tapped / results matching or suggested
      // restaurant/hint tapped / no results
      if (_lc.searchInput.length > 0) {
        firebaseObject.search_term = _lc.searchInput;
        firebaseObject.ss_search_term = _lc.searchInput;
      }

    } else { //error
      firebaseObject = {
        address_latitude: $scope._rc.variables.address.latitude,
        address_longitude: $scope._rc.variables.address.longitude,
        error_code: obj.status,
        error_message: obj.data.detail,
        search_term: _lc.searchTerm
      };
    }

    if (window.env.name === 'QA') console.log('firebase: ', firebaseObject);

    if (window.firebase_an) {
      window.firebase_an.logEvent(e, firebaseObject);
    }
  };

})
.filter('searchFilterIds', function($filter) {
	return function(items, filterIds, index) {
    if (filterIds !== null && filterIds.length > 0) { // filter not empty
      var result = [];
      angular.forEach(items, function(item) {
        if (filterIds.includes(item.tiles[0].payload.id)) {
          result.push(item);
        }
      });
			return result;
		} else { // filter empty
			return items;
		}
	};
});
